<template>
  <div class="md-layout" v-if="staff">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h4 class="title">
          Details
        </h4>
      </md-card-header>
      <md-card-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="title">Title</label>
                <md-select v-model="staff.title" name="title" id="title">
                  <md-option value="Mr">Mr</md-option>
                  <md-option value="Mrs">Mrs</md-option>
                  <md-option value="Miss">Miss</md-option>
                  <md-option value="Ms">Ms</md-option>
                  <md-option value="Dr">Dr</md-option>
                  <md-option value="Prof">Prof</md-option>
                  <md-option value="Rev">Rev</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>First Name</label>
                <md-input v-model="staff.first_name" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>Last Name</label>
                <md-input v-model="staff.last_name" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Contact Number</label>
                <md-input v-model="staff.tel_num" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="staff.email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="staff.address_1" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="staff.address_2" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>City</label>
                <md-input v-model="staff.city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>County/State</label>
                <md-input v-model="staff.county" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label for="country">Country</label>
                <md-select v-model="staff.country" name="country" id="country">
                  <md-option
                    v-for="country in countries"
                    :key="country"
                    :value="country"
                  >
                    {{ country }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Postcode</label>
                <md-input v-model="staff.postcode" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                class="md-raised md-success mt-4"
                @click.prevent="update"
                >{{ updateButtonText }}</md-button
              >
            </div>
          </div>
        </form>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import staffApi from "@/services/api/staff";
import optionsApi from "@/services/api/options";

export default {
  props: ["staff"],

  data() {
    return {
      countries: []
    };
  },

  computed: {
    updateMode: function() {
      return this.staff.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Add";
    }
  },

  methods: {
    update() {
      let save = null;
      let message = "";

      switch (this.updateMode) {
        case "UPDATE":
          save = staffApi.updateStaff(this.staff);
          message = "Updated!";
          break;

        default:
          save = staffApi.createStaff(this.staff);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("staffUpdated", {
          staff: response.data,
          mode: this.updateMode
        });
      });
    }
  },

  created() {
    optionsApi.countries().then(response => {
      this.countries = response.data;
    });
  }
};
</script>
